import { Box, Spinner } from '@factorialco/deprecated-design-system'
import {
  PerformanceProcessTargetTeamInfoDocument,
  PerformanceTargetTeamInfoAccessFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { TeamInsights } from 'modules/performance_process/components/insights/TeamInsights'
import { OverviewTargets } from 'modules/performance_process/components/overview/Targets'

export const TeamInfo: React.FC<{
  targetAccess: PerformanceTargetTeamInfoAccessFragment
  reviewId: number
}> = ({ targetAccess, reviewId }) => {
  const { data, loading, error } = useQuery(PerformanceProcessTargetTeamInfoDocument, {
    variables: { reviewId: Number(reviewId) },
  })

  const review = data?.performance.reviewProcess
  const targetEmployeeId = targetAccess.employee?.id
  if (loading || error)
    return (
      <Box justifyContent="center" alignItems="center" paddingY="s48" height="full">
        <Spinner />
      </Box>
    )

  return (
    <Box gap="s32">
      <TeamInsights reviewId={reviewId} forAccessId={targetAccess.id} />
      {review && targetEmployeeId && (
        <OverviewTargets
          review={review}
          hasFullVisibility={review._policies?.fullVisibility?.can ?? false}
          defaultManagerFilterForEmployeeId={targetEmployeeId}
          hideManagerFilter
          showTeamInsights={false}
          showEmployeeScores={!!review.scoreConfiguration}
        />
      )}
    </Box>
  )
}
